export default {
    en: {
        id: 'exercise1',
        answers: [
            {
                title: `<div class="box-title">Offer Risk Management Study - RM benchmarking service, updated periodically, with analytical insights into developing Credit Risk trends</div>
                        <div>
                            - Risk performance benchmarks
                        </div>
                        <div>
                            - Forecast of CR trends
                        </div>
                        <div>
                            - Impact of best practices on business and organizational performance

                        </div>
                        <div>
                            - Decision support tool (modeling and scoring) in shaping credit risk policy, market strategy
                        </div>`,
                answer: 1,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Difficult to develop strategies to optimize portfolio risk</div>`,
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Better risk policy formulation and management</div>
                        <div>
                            - Meaningful perspective on key underpinnings of RM practices
                        </div>`,
                answer: 3,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Issuers asking us for insights on</div>
                        <div>
                            - CH risk activities in other banks
                        </div>
                        <div>
                            - Practices they are adopting
                        </div>`,
                answer: 4,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Current Risk Management benchmarking offerings rovide only rear view mirror on past or recent performance</div>
                        <div>
                            - No projections of Credit Risk trends
                        </div>
                        <div>
                            - No insights into CH risk profiles in post-acquisition stage of the credit life cycle
                        </div>`,
                answer: 5,
                hasArrow: true
            }
        ],
        image: '5b1-1.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5d/writingProposalsPlans/i18n/exercise1.js